// extracted by mini-css-extract-plugin
export default {"section":"style_section__TVSI9","heading":"style_heading__b8Htg"};